var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTranslationsInactive = function SvgTranslationsInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6E5F2",
    d: "M7.5 3A4.5 4.5 0 0 0 6 11.744v2.532a.3.3 0 0 0 .512.212L9 12h3.5a4.5 4.5 0 1 0 0-9h-5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2C9DE",
    d: "M17 18v2.276a.3.3 0 0 1-.512.212L14 18h-2a4 4 0 0 1 0-8h5a4 4 0 0 1 0 8Z"
  })));
};
export default SvgTranslationsInactive;